module.exports = __webpack_public_path__ + "static/img/icon-在线上传-1@2x.5ffca93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/order/icon-在线上传-1@2x.png
// module id = HzN9
// module chunks = 4